import { useFetch } from 'context/fetch';
import { useQuery, useMutation } from 'react-query';

import { ME_QUERY_KEY, QUERY_KEY } from './constants';
import { meQuery, usersQuery } from './queries';
import { registerMutation, deleteRegularUserMutation } from './mutations';

export const useMeQuery = (props = {}) => {
  const { key = ME_QUERY_KEY, config = {} } = props;
  const { client } = useFetch();

  return useQuery([key], () => client.request(meQuery), config);
};

export const useUsersQuery = (props = {}) => {
  const { key = QUERY_KEY, config = {} } = props;
  const { client } = useFetch();

  return useQuery([key], () => client.request(usersQuery), config);
};

export const useRegisterMutation = (config = {}) => {
  const { client } = useFetch();
  return useMutation(
    (values) => client.request(registerMutation, values),
    config
  );
};

export const useDeleteRegularUserMutation = (config = {}) => {
  const { client } = useFetch();
  return useMutation(
    (id) => client.request(deleteRegularUserMutation, { id }),
    config
  );
};
